// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   CARD
========================================= */

.DeviceStateCard_card__ADk8k {
    border-radius: 12px;
    z-index: 1;
    padding: 8px 12px;
    background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/Latency/DeviceHealthCard/DeviceStateCard.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;IACI,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,yBAAyB;AAC7B","sourcesContent":["/* =========================================\n   CARD\n========================================= */\n\n.card {\n    border-radius: 12px;\n    z-index: 1;\n    padding: 8px 12px;\n    background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `DeviceStateCard_card__ADk8k`
};
export default ___CSS_LOADER_EXPORT___;
